// ============================================================================
// REFERENCE SERVICE — read-only bms reference data (countries, ...).
// ============================================================================

import { get } from '../client/axiosClient';
import { buildEndpoint, buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type { ApiResponse, CountryDto } from '../types';

class ReferenceService {
  async getCountries(search?: string): Promise<CountryDto[]> {
    const base = buildEndpoint('/reference/countries');
    const url = search ? buildEndpointWithQuery(base, { search }) : base;
    const r = await get<ApiResponse<CountryDto[]>>(url);
    return r.data.data ?? [];
  }
}

export const referenceService = new ReferenceService();
export default referenceService;
